import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useAuth } from './AuthContext';
import apiService from '../services/apiService';
import { API_ENDPOINTS } from '../config/api';

const LegalAcceptanceContext = createContext(null);

export const LegalAcceptanceProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [pending, setPending] = useState(null);

  const checkPending = useCallback(async () => {
    try {
      const response = await apiService.get(API_ENDPOINTS.LEGAL.PENDING);
      setPending(response.data.pending);
    } catch (error) {
      console.error('Legal pending check failed:', error);
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      checkPending();
    } else {
      setPending(null);
    }
  }, [isAuthenticated, checkPending]);

  const acceptPending = useCallback(async () => {
    if (!pending) return;
    await apiService.post(API_ENDPOINTS.LEGAL.ACCEPT, { documentId: pending.document.id });
    setPending(null);
  }, [pending]);

  return (
    <LegalAcceptanceContext.Provider value={{ pending, acceptPending, checkPending }}>
      {children}
    </LegalAcceptanceContext.Provider>
  );
};

export const useLegalAcceptance = () => useContext(LegalAcceptanceContext);
